import * as types from "./actionTypes";

export const getSoftwareSetting = () => {
  return {
    type: types.GET_PROJECT_SOFTWARE_SETTING_REQUEST
  };
};
export const getSoftwareSettingSuccess = data => {
  return {
    type: types.GET_PROJECT_SOFTWARE_SETTING_SUCCESS,
    data: data
  };
};
export const getSoftwareSettingFailure = error => {
  return {
    type: types.GET_PROJECT_SOFTWARE_SETTING_FAILURE,
    error
  };
};

export const softwareSettingStore = data => {
  return {
    type: types.PROJECT_SOFTWARE_SETTING_STORE_REQUEST,
    data: data
  };
};
export const softwareSettingStoreSuccess = data => {
  return {
    type: types.PROJECT_SOFTWARE_SETTING_STORE_SUCCESS,
    data: data
  };
};
export const softwareSettingStoreFailure = () => {
  return {
    type: types.PROJECT_SOFTWARE_SETTING_STORE_FAILURE
  };
};

export const transactionFormSettingStore = data => {
  return {
    type: types.PROJECT_TRANSACTION_FORM_SETTING_STORE_REQUEST,
    data: data
  };
};

export const transactionFormSettingStoreSuccess = () => {
  return {
    type: types.PROJECT_TRANSACTION_FORM_SETTING_STORE_SUCCESS
  };
};

export const transactionFormSettingStoreFailure = () => {
  return {
    type: types.PROJECT_TRANSACTION_FORM_SETTING_STORE_FAILURE
  };
};

export const paymentValidationSettingStore = data => {
  return {
    type: types.PROJECT_PAYMENT_VALIDATION_SETTING_STORE_REQUEST,
    data: data
  };
};

export const paymentValidationSettingStoreSuccess = () => {
  return {
    type: types.PROJECT_PAYMENT_VALIDATION_SETTING_STORE_SUCCESS
  };
};

export const paymentValidationSettingStoreFailure = () => {
  return {
    type: types.PROJECT_PAYMENT_VALIDATION_SETTING_STORE_FAILURE
  };
};

export const getSoftwareList = () => {
  return {
    type: types.PROJECT_SETTING_ACCOUNTING_SOFTWARE_LIST_REQUEST
  };
};
export const getSoftwareListSuccess = data => {
  return {
    type: types.PROJECT_SETTING_ACCOUNTING_SOFTWARE_LIST_SUCCESS,
    data: data
  };
};
export const getSoftwareListFailure = () => {
  return {
    type: types.PROJECT_SETTING_ACCOUNTING_SOFTWARE_LIST_FAILURE
  };
};

export const getSubSoftwareList = data => {
  return {
    type: types.PROJECT_SETTING_SUB_ACCOUNTING_SOFTWARE_LIST_REQUEST,
    data
  };
};

export const getSubSoftwareListSuccess = data => {
  return {
    type: types.PROJECT_SETTING_SUB_ACCOUNTING_SOFTWARE_LIST_SUCCESS,
    payLoad: data
  };
};

export const getSubSoftwareListFailure = error => {
  return {
    type: types.PROJECT_SETTING_SUB_ACCOUNTING_SOFTWARE_LIST_FAILURE,
    error
  };
};

export const sharedContacts = () => {
  return {
    type: types.SHARED_CONTACTS_REQUEST
  };
};

export const sharedContactsSuccess = data => {
  return {
    type: types.SHARED_CONTACTS_SUCCESS,
    payLoad: data
  };
};

export const sharedContactsFailure = () => {
  return {
    type: types.SHARED_CONTACTS_FAILURE
  };
};

export const setUserState = (userId, action) => {
  return {
    type: types.SET_USER_STATE_REQUEST,
    userId,
    action
  };
};

export const setUserStateSuccess = data => {
  return {
    type: types.SET_USER_STATE_SUCCESS,
    payLoad: data
  };
};

export const setUserStateFailure = data => {
  return {
    type: types.SET_USER_STATE_FAILURE,
    payLoad: data
  };
};

export const showUser = userId => {
  return {
    type: types.SHOW_USER_REQUEST,
    userId
  };
};

export const showUserSuccess = data => {
  return {
    type: types.SHOW_USER_SUCCESS,
    payLoad: data
  };
};

export const showUserFailure = () => {
  return {
    type: types.SHOW_USER_FAILURE
  };
};

export const updateUser = (userId, data) => {
  return {
    type: types.UPDATE_USER_REQUEST,
    userId,
    data
  };
};

export const updateUserSuccess = data => {
  return {
    type: types.UPDATE_USER_SUCCESS,
    payLoad: data
  };
};

export const updateUserFailure = () => {
  return {
    type: types.UPDATE_USER_FAILURE
  };
};
